// extracted by mini-css-extract-plugin
export default {"header":"PiyWtRtIoRY4gdUkOCiX"};